import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { Typography } from '@/components/shared/Typography';
import { useLazyVideoSource } from '@/hooks/useLazyVideoSource';
import { useViewportVideosPlayback } from '@/hooks/useViewportVideosPlayback';
import css from './style.module.scss';
const MainAwardSegment = () => {
  const $ = _c(9);
  const segmentRef = useRef(null);
  const shouldLoad = useLazyVideoSource(segmentRef);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [segmentRef];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useViewportVideosPlayback(t0);
  let t1;
  if ($[1] !== shouldLoad) {
    t1 = shouldLoad ? <><source src="/assets/video/mov/award-orpetron.mov" type={"video/quicktime; codecs=\"hvc1\""} /><source src="/assets/video/webm/award-orpetron.webm" type="video/webm" /></> : null;
    $[1] = shouldLoad;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <video loop={true} muted={true} playsInline={true} preload="none" className={css.video} controls={false}>{t1}</video>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography uppercase={true} className={css.title} variant="h4" tag="h3">We’re website of the year winners</Typography>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography className={css.description} variant="body-l" tag="p"><span>Funky Wolves,</span><span className={css.descriptionYear}>2022</span></Typography>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2) {
    t5 = <div ref={segmentRef} className={css.segment}>{t2}{t3}{t4}</div>;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default MainAwardSegment;